import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, Subscription } from "rxjs";
import { ReportingPagesService } from "./reporting-pages.service";

@Injectable({
  providedIn: "root",
})
export class ReportingPagesDataService {
  apiEP: string = window.apiUrl;
  legacyUrl: string = window.caUrl;
  coveragestatusList: Array<any> = [];
  subscription: Subscription;
  constructor(
    private http: HttpClient,
    private service: ReportingPagesService,
  ) {}

  getReportGridData(params): Observable<any> {
    const filterUrl = this.service.getFilterUrl(params);
    return this.http.get(
      `${this.apiEP}/${params.baseUrl}page=${params.pageIndex}&sord=${params.sortOrder}&sidx=${params.sortKey}&rows=${params.pageSize}${filterUrl}`,
    );
  }

  getWatchlistData(userId): Observable<any> {
    return this.http.get(
      `${this.apiEP}/watcher/get_watchers_only/?userid=${userId}`,
    );
  }

  createExcelDownloadUsingHiddenForms(exportObject): any {
    // let data = {wholeObject: exportObject}
    const form = document.createElement("form");
    form.style.display = "none";
    form.method = "post";
    form.action = `${this.apiEP}/api/jqgridexporttoexcel/`;
    const input = document.createElement("input");
    input.setAttribute("name", "wholeObject");
    input.setAttribute("value", JSON.stringify(exportObject));
    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
  }

  getBrokerColumnMetaInfo(brokerId): Observable<any> {
    return this.http.get(
      `${this.apiEP}/api/getcolumnmetainformation?source=${brokerId}`,
    );
  }

  getAnalystMetaInfo(analystId): Observable<any> {
    return this.http.get(
      `${this.apiEP}/api/getcolumnmetainformation?analystid=${analystId}`,
    );
  }

  getSelectedModelColumns(): Observable<any> {
    return this.http.get(
      `${this.apiEP}/api/get_columns_selected?moduledimension=modellibrary&dimensionname=ColumnSelector`,
    );
  }

  updateSelectedColumnsInModels(columns): Observable<any> {
    const dataToSend = { jsonData: { columns: columns } };
    return this.http.post(
      `${this.apiEP}/api/update_columns_selected`,
      dataToSend,
    );
  }

  getHistoricalModalData(params): Observable<any> {
    return this.http.get(
      `${this.apiEP}/api/show_more_models_api?company_id=${params.companyId}&source_id=${params.sourceId}&limit=-1`,
    );
  }

  getCoverageStatus(): Observable<any> {
    return this.http.get(`${this.apiEP}/api/get_coveragestatus_dropdown`);
  }

  getModelsColumnNameMapping(): {} {
    const colNameMap = {
      sector: "Sector",
      industry: "Industry",
      companyname: "Company",
      ticker: "Ticker",
      bloombergcode: "Bloomberg Ticker",
      country: "Country",
      region: "Region",
      companyinitiated: "Initiation Date",
      lastreportingdate: "Last revision date",
      analyst: "Analyst",
      modeldate: "Model Date",
      peers: "Peers",
      coveredsource: "Sources",
      size: "Model",
      source: "Source",
      "Coverage Status": "Coverage Status",
      "In VA Consensus?": "In VA Consensus?",
      status: "Status",
      views: "Views",
      username: "User Name",
      firstname: "First Name",
      lastname: "Last Name",
      email: "Email",
      created: "Created Date",
      staffstatus: "Staff Status",
      is_active: "Status",
      name: "Broker name",
      total: "No. of Company Models Available",
      vaconsensus: "No. of Companies in VA Consensus",
      isentitled: "Entitlement Status",
      disclosure: "Disclosures",
      waterfrontBadge: "Badge",
      historicalModelLink: "Archive",
      reuterscode: "Reuters Ticker",
    };
    return colNameMap;
  }
  getCoverageStatusValue(): any {
    if (!this.subscription) {
      this.subscription = this.getCoverageStatus().subscribe((response) => {
        this.coveragestatusList.push({ val: "", display: "[All]" });
        response.forEach((item) => {
          this.coveragestatusList.push({
            val: item.toLowerCase(),
            display: item,
          });
        });
      });
    }
    return this.coveragestatusList;
  }
}
